export default {
    common: {
        title: 'Session Results',
    },
    studentResult: {
        subtitle: "Let's take a look at what you've learned!",
        totalActivities: 'You completed a total of { count } activities!',
    },
    teacherResult: {
        sessionInfo: 'Session Information',
        sessionInfoItem: {
            title: 'Basic Session Information',
            date: 'Date',
            duration: 'Duration',
            studentCount: 'Participants',
            curriculum: 'Sub-unit',
        },
        noModules: 'No activities have been conducted.',
        showMvp: 'MVP Announcement',
    },
};
